import { Suspense } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router';
import { AppProviders } from '@/app/providers/AppProviders';
import { ErrorBoundary } from '@/app/ErrorBoundary';
import { routes } from '@/app/routes';
import { PageSpinner } from '@/components/ui/PageSpinner';
import { useTheme } from '@/hooks/useTheme';

// Created once at module scope — building a router inside the component body
// would remount the whole tree on every render.
const router = createBrowserRouter(routes);

export function App() {
    // Keeps <html data-theme> in sync on every route, signed in or out.
    useTheme();

    return (
        <ErrorBoundary>
            <AppProviders>
                <Suspense fallback={<PageSpinner />}>
                    <RouterProvider router={router} />
                </Suspense>
            </AppProviders>
        </ErrorBoundary>
    );
}
